module.exports = __webpack_public_path__ + "static/media/slider-03.4e54f761.jpg";